import { Link } from "react-router-dom";
import { Seo } from "@shared/components";

import { Button } from "@/shared/ui/components";

export function NotFoundPage(): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background text-foreground">
      <Seo
        title="Страница не найдена (404) | Polotno"
        description="Запрошенная страница не существует или была перемещена."
        path="/404"
        noindex
      />
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary">404</h1>
        <p className="mt-4 text-2xl font-semibold">Страница не найдена</p>
        <p className="mt-2 text-muted-foreground">К сожалению, мы не смогли найти страницу, которую вы ищете.</p>
        <div className="mt-6">
          <Button asChild>
            <Link to="/">На главную</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
